module.exports = __webpack_public_path__ + "assets/img/5f364de3ffb73036d316894cd2b49c8e.png";